import PropTypes from 'prop-types';

var propTypes = {
    label: PropTypes.string,
    isValid: PropTypes.bool,
    errorMessage: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    alignRight: PropTypes.bool,
    primaryCondition: PropTypes.string,
    secondaryCondition: PropTypes.string,
    type: PropTypes.oneOf(['text', 'number', 'tel', 'password']),
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
};
var defaultProps = {
    alignRight: false,
};

export { defaultProps, propTypes };
